import { Model } from "@interfaces/model.interface";

export interface PurchaseLogWorkOrder extends Model {
	purchaseLogId: number;
	workOrderId: number;
}

export class PurchaseLogWorkOrder implements PurchaseLogWorkOrder {
	constructor(data?: Partial<PurchaseLogWorkOrder>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}